import {getUserData} from '@common'
import {APIMethod} from '@enums'
import {getUserSelectionAtom} from '@state'

import {fetchData} from 'api/api'
import {getDefaultStore} from 'jotai'

import {AccessoryRequest, AccessoryResponse} from './types'

/**
 * @returns All Accessories for the current user's company
 */
export const getAccessories = async (): Promise<AccessoryResponse[]> => {
  const currentUser = getUserData()
  const userSelectionMap = getDefaultStore().get(getUserSelectionAtom)
  const userSelection = userSelectionMap[currentUser.id]

  return fetchData<undefined, AccessoryResponse[]>({
    method: APIMethod.GET,
    url: `accessory/company/${userSelection?.companyId || ''}`,
  })
}

/**
 * @param id Accessory ID
 * @returns A single Accessory
 */
export const getAccessoryById = async (id: string): Promise<AccessoryResponse> => {
  return fetchData({
    method: APIMethod.GET,
    url: `accessory/${id}`,
  })
}

/**
 * @param id Accessory ID
 * @param body Accessory payload
 * @returns Updated Accessory
 */
export const updateAccessory = async (id: string, body: AccessoryRequest): Promise<AccessoryResponse> => {
  return fetchData({
    method: APIMethod.PUT,
    url: `accessory/${id}`,
    body,
  })
}

/**
 * @param body Accessory payload
 * @returns Created Accessory
 */
export const createAccessory = async (body: AccessoryRequest): Promise<AccessoryResponse> => {
  return fetchData({
    method: APIMethod.POST,
    url: `accessory`,
    body,
  })
}
